import { t } from './i18n.es.js';
import React from 'react';
import { styled, CountdownText } from '@teko/ui';
import { ClockAlternativeOutlined, FlashSaleFilled } from '@teko/ds-icon';

var background = "https://shopfront-cdn.tekoapis.com/static/242be5f20fc8b658.svg";

const TimeMessageWrapper = styled.div `
  color: white;
  text-transform: initial;
  font-weight: normal;
  text-overflow: ellipsis;
  overflow: hidden;
`;
const BoldWrapper = styled.span `
  font-weight: bold;
`;
const LargeTextWrapper = styled.span `
  margin-right: 4px;
`;
const StyledClockOutline = styled(ClockAlternativeOutlined) `
  margin-bottom: 2px;
`;
const FlashSaleBadgeTime = ({ size, endAt }) => {
    return (React.createElement(TimeMessageWrapper, null,
        size == 'lg' && (React.createElement(LargeTextWrapper, null,
            React.createElement(StyledClockOutline, { color: "#ffffff", size: 20 }))),
        React.createElement(BoldWrapper, null,
            React.createElement(CountdownText, { date: endAt }))));
};

const Wrapper = styled.div((props) => {
    const styles = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: `${props.backgroundColor || 'red'}`,
        backgroundImage: `url("${background}"), ${!props.backgroundColor &&
            (props.backgroundLinearGradient ||
                'linear-gradient(275deg, #ff8949, #eb2101)')}`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        borderRadius: '2.5rem!important',
    };
    if (props.size == 'lg') {
        styles.height = '2.5rem';
        styles.lineHeight = '2.5rem';
        styles.padding = '8px';
        styles.paddingRight = '12px';
        styles.fontSize = '13px';
    }
    else {
        styles.height = '1.2rem';
        styles.lineHeight = '1rem';
        styles.padding = '4px';
        styles.paddingRight = '8px';
        styles.fontSize = '10px';
    }
    return styles;
});
const ProductSold = styled.div(({ size }) => `
  color: #fff;
  margin-left: ${size === 'sm' ? '4' : '8'}px;
  font-size: ${size === 'sm' ? '8' : '10'}px;
  display: flex;
  align-items: center;
`);
const ProductSoldWrapper = styled.div `
  display: flex;
  align-items: center;
  margin-right: 0.5rem;
`;
const FlashSaleBadge = ({ sold, total, endAt, backgroundLinearGradient, backgroundColor, size = 'sm', className, stock, }) => {
    const remain = Math.min(total - sold, stock);
    const message = sold / total > 0.9 || remain < 5
        ? t('Sắp cháy hàng')
        : t('Còn lại {{remain}}', { remain: remain });
    const hidden = remain <= 0;
    if (hidden) {
        return null;
    }
    return (React.createElement(Wrapper, { className: className, backgroundLinearGradient: backgroundLinearGradient, backgroundColor: backgroundColor, size: size },
        React.createElement(ProductSoldWrapper, null,
            React.createElement(FlashSaleFilled, { color: "#FFD591", size: size == 'lg' ? 24 : 16 }),
            React.createElement(ProductSold, { size: size }, message)),
        endAt && React.createElement(FlashSaleBadgeTime, { size: size, endAt: endAt })));
};

export { FlashSaleBadge as F };
